import React from 'react';
import { withTranslation } from "react-i18next";
import { ThemeProvider, Textfield } from '@workboard/wobo-ui';
import { Select as MatSelect, InputLabel } from '@material-ui/core';
import { reactLoader, removeReactLoader, constructNestedKRPayload } from '../../../utils/common';
import { ButtonComp } from "../../inputs/buttons.component";
import GoalServices from '../../../services/goal.services';
import KpiMarketPlaceKrWizardPopup from './kpiMarketPlaceKrWizardPopup';
import AddKrTag from "../../../krTags/components/addkrTag.component"
import RetainUpdateModal from '../../../components/retainUpdateModal.component';
import PermissionComp from "./key_results/permission.component";
import NestedInlineComp from './key_results/NestedInline.component';
import { krdetailConstants } from '../../../constants/krdetails.constants';
import { isKpiIframeMetricTargetApp, isExternalMetricV2AppId, getAutomatedTargetFromMetricData } from '../../../utils/kpi-market-place-util';
import {
  buildEditExtSourceData,
  buildExternalSourceForPayload,
  parseMetricExternalSourceData,
} from '../../../utils/kpi-v2-wizard-payload';
import Customokr from '../../../components/custom_fields/customobj/Customokr';
import { ErrorTextComp } from "../../../components/inputs/fields.component";
import HelpTextComp from '../../helper/helptext.component';
import KpiDataSourceComponent from './kpiDataSource.component';
import KrRelationshipWrapper from './key_results/krRelationshipWrapper';
import { AddFinancialTargetsButton } from './AddFinancialTargetsButton';
import { KpiSearchModal } from './kpiSearchModal';
import { resolveKrSaveGoalId } from '../../../utils/kpi-market-place-util';

class KpiMarketPlaceDataSourceEdit extends React.Component {
	constructor(props) {
		super(props);
    const isKrCoOwnerEnabled = window.wbConfig.isKrCoOwnerEnabled ?? false;
		this.state = ({
      kpiType:
				this.props.item?.ext_app_id == krdetailConstants.WOBO_KPI_ID
					? 'wobo_kpi'
					: this.props.kpiType,
			showModal: this.props.showModal,
			isSelected: this.props.isSelected,
      closePopup: this.props.closePopup,
      item: this.props.item,
      tags:[],
      startValue: this.getCurrentStartValue(),
      targetValue: this.getCurrentTargetValue(),
      stretchValue: this.getCurrentStretchValue(),
      targetUpperLimit: this.props.item && this.props.item.upper_limit ? this.props.item.upper_limit : "",
      targetLowerLimit: this.props.item && this.props.item.lower_limit ? this.props.item.lower_limit : "",

      dsMetricValue: this.getCurrentMetricValue(),
      committedKRFlag: this.getCurrentCommittedFlag(),
      automateTargetFlag: this.getCurrentautomateTargetFlagForItem(this.props.item),
      offsetUpdateFlag: this.getCurrentOffsetUpdateFlag(),
      offsetUpdateValue: this.getCurrentOffsetUpdateValue(),
      measureType: this.getCurrentMeasureType(),
      progType: this.getCurrentProgressType(),
      intervalType: this.getCurrentIntervalType(),
      dayType: this.getCurrentDayType(),
      externalSrc: false,
      titleRetain: "",
      contentRetain: "",
      selectedTypeOpt:'',
      exclude: this.getCurrentExclude(),

      teamPermissionSelected:
				this.props.item && this.props.item.permission_teams
					? this.props.item.permission_teams
					: [],
			bizPermissionSelected:  this.props.item && this.props.item.permission_biz ? this. props.item.permission_biz : [],
			permissionstate:
				this.props.item && this.props.item.permission
					? this.props.item.permission.split(",").map(Number)
					: this.props.goalDetails.type == 1 ? [8] : [10],
			permissionHelpPopUp: false,

      externalSource: this.getCurrentExternalSource(),
      dataSource: null,
      achieve_target: this.props.item.achieve_target,
      error: '',
      lastSourceType:this.props.lastSourceType ? this.props.lastSourceType : '',
      nplTags:this.props.nplTags ? this.props.nplTags : [],
      selectednlplTags:this.props.selectednlplTags ? this.props.selectednlplTags : [],
      selectednlplTagsName:this.props.selectednlplTagsName ? this.props.selectednlplTagsName : [],
      tagsList:this.props.tagsList ? this.props.tagsList:[],
      customInputData:[],
      isCustomSave:[],
      errors: {},
      isStretchEnabled: this.props.addOkrData.isStretchEnabled ?? this.props.goalDetails.isStretchEnabled ?? false,
      coOwners: isKrCoOwnerEnabled ? (this.props.item.coOwners && this.props.item.coOwners.length > 0 ? this.props.item.coOwners : (this.props.coOwners && this.props.coOwners.length > 0 ? this.props.coOwners : [])) : [],
      checkRolFlag: this.props.item?.is_real_owner_rol != undefined ? true : false,
    });

    this.handleResultValueChange = this.handleResultValueChange.bind(this);
    this.handleCommittedKRChange = this.handleCommittedKRChange.bind(this);
    this.handleAutomateTargetFlagChange = this.handleAutomateTargetFlagChange.bind(this);
    this.handleMeasurValueChange = this.handleMeasurValueChange.bind(this);
    this.handleDayTypeValueChange = this.handleDayTypeValueChange.bind(this);
    this.handleIntervalValueChange = this.handleIntervalValueChange.bind(this);
    this.handleProgressTypeChange = this.handleProgressTypeChange.bind(this);

    this.setRightPaneValue = this.setRightPaneValue.bind(this);
    this.saveKr = this.saveKr.bind(this);
    this.saveData = this.saveData.bind(this);
    this.exitDeleteModal = this.exitDeleteModal.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.handleSaveComplete = this.handleSaveComplete.bind(this);
    this.changeRadioOpt = this.changeRadioOpt.bind(this);
    this.saveItems = this.saveItems.bind(this);

    this.permissionData = this.permissionData.bind(this);
    this.teamPermissionData = this.teamPermissionData.bind(this);
	  this.bizPermissionData =  this.bizPermissionData.bind(this);
    this.updateTags = this.updateTags.bind(this);
    this.isRequiredCustomOkrFiled = this.isRequiredCustomOkrFiled.bind(this);
    this.handleExcludeChange = this.handleExcludeChange.bind(this);
    this.renderError = this.renderError.bind(this);
    this.handleOffsetUpdateFlagChange = this.handleOffsetUpdateFlagChange.bind(this);
    this.handleOffsetUpdateValueChange = this.handleOffsetUpdateValueChange.bind(this);
    this.handleSaveWoboKpi = this.handleSaveWoboKpi.bind(this);
    this.onSaveWoboKpi = this.onSaveWoboKpi.bind(this);

	}

  isWoboKpiMetric(metric) {
    if (!metric) {
      return false;
    }
    return metric.ext_app_id == krdetailConstants.WOBO_KPI_ID;
  }

  shouldUseWoboKpiSearchModal() {
    return (
      this.state.kpiType === 'wobo_kpi'
      || this.props.kpiType === 'wobo_kpi'
      || this.isWoboKpiMetric(this.props.item)
      || this.isWoboKpiMetric(this.state.item)
    );
  }

  componentWillUnmount() {
		this.props.kpiRef(null)
	}

	async componentDidMount() {
		this.props.kpiRef(this);
    const dataSource = await this.getDataSource();
    const stateUpdate = { dataSource };
    const automateFromDs =
      dataSource?.data && typeof dataSource.data === 'object'
        ? this.normalizeAutomateTargetFlag(dataSource.data.automateTargetFlag)
        : null;
    const effectiveAutomate =
      this.state.automateTargetFlag !== null && this.state.automateTargetFlag !== undefined
        ? this.state.automateTargetFlag
        : automateFromDs;

    if (dataSource && effectiveAutomate) {
      const targetFromDs = this.getDataSourceTargetForForm(dataSource);
      if (targetFromDs != null && targetFromDs !== '') {
        stateUpdate.targetValue = targetFromDs;
      }
    }
    if (this.props.item?.ext_app_id == krdetailConstants.WOBO_KPI_ID) {
      stateUpdate.kpiType = 'wobo_kpi';
    }
    this.setState(stateUpdate);
	}

	async componentDidUpdate(prevProps) {
		const prevExternalAppSources = prevProps.item?.external_app_sources?.[0]?.id;
		const currentExternalAppSources = this.props.item?.external_app_sources?.[0]?.id;

		if (prevExternalAppSources !== currentExternalAppSources) {
			this.setState({ item: this.props.item });

			const dataSource = await this.getDataSource(this.props.item);
			if (dataSource) {
				const isWoboKpi = this.props.item?.ext_app_id == krdetailConstants.WOBO_KPI_ID;
				const kpiType = isWoboKpi ? 'wobo_kpi' : (this.props.kpiType || null);
				const automateTargetFlag = this.getCurrentautomateTargetFlag();
				const automateFromDs =
					dataSource?.data && typeof dataSource.data === 'object'
						? this.normalizeAutomateTargetFlag(dataSource.data.automateTargetFlag)
						: null;
				const effectiveAutomate =
					automateTargetFlag !== null && automateTargetFlag !== undefined
						? automateTargetFlag
						: automateFromDs;
				const stateUpdate = {
					dataSource,
					kpiType,
					externalSource: this.getCurrentExternalSource(this.props.item),
				};
				if (dataSource && effectiveAutomate) {
					const targetFromDs = this.getDataSourceTargetForForm(dataSource);
					if (targetFromDs != null && targetFromDs !== '') {
						stateUpdate.targetValue = targetFromDs;
					}
				}
				this.setState(stateUpdate);
			}
		}
	}

  closePopup(options = {}) {
    const { fromSaveComplete = false } = options;
    const metricId = this.props.item?.id ?? this.state.item?.id;

    if (metricId) {
      const originalExternalSource = this.getCurrentExternalSource();
      this.setState({
        showModal: false,
        externalSource: originalExternalSource,
      });
      return;
    }

    this.setState({ showModal: false });

    if (!fromSaveComplete && this.props.goBackFromMitNestedKr) {
      this.props.goBackFromMitNestedKr();
      return;
    }
    this.props.closePopup();
  }

  handleSaveComplete(metric) {
    this.setState({ achieve_target: null}, async () => {
      const dataSource = await this.getDataSource();
      const syncedAutomate = this.getCurrentautomateTargetFlagForItem(metric);
      const automateFromDs =
        dataSource?.data && typeof dataSource.data === 'object'
          ? this.normalizeAutomateTargetFlag(dataSource.data.automateTargetFlag)
          : null;
      const effectiveAutomate =
        syncedAutomate !== null && syncedAutomate !== undefined ? syncedAutomate : automateFromDs;
      let targetValue = metric?.target;
      if (dataSource && effectiveAutomate) {
        const targetFromDs = this.getDataSourceTargetForForm(dataSource);
        if (targetFromDs != null && targetFromDs !== '') {
          targetValue = targetFromDs;
        }
      }
      this.setState({
        achieve_target: metric?.achieve_target,
        externalSource: this.getCurrentExternalSource(metric),
        dataSource: dataSource,
        measureType: metric?.metric,
        targetValue,
        ...(effectiveAutomate !== null && effectiveAutomate !== undefined
          ? { automateTargetFlag: effectiveAutomate }
          : {}),
      });
    });

    if (this.props.updateSingleItem) {
      this.props.updateSingleItem(metric);
    }
    this.closePopup({ fromSaveComplete: true });
  }

	handleSaveWoboKpi (selectedKpi) {
    reactLoader();
    const goalService = new GoalServices();
    const goalId = resolveKrSaveGoalId(this.props.item, this.props.addOkrData?.goalDetails || this.props.goalDetails);
    const realOwnerId = this.props.realOwner ? this.props.realOwner.id : this.props.item.real_owner;
    const payload = {
      ...this.props.item,
      source: krdetailConstants.SOURCE_EXT_SOURCES,
      ext_app_id: krdetailConstants.WOBO_KPI_ID,
      real_owner: realOwnerId,
      owner: realOwnerId,
      kpiId: selectedKpi.id,
      external_app_sources: [{
        id: selectedKpi?.id,
        external_app_id: krdetailConstants.WOBO_KPI_ID,
        data: JSON.stringify({
          kpiId: selectedKpi?.id,
        })
      }],
    };

    if (this.props.mitChildKr) {
      const offsetUpdateValue = this.state.offsetUpdateFlag ? +this.state.offsetUpdateValue : null;
      payload.achieve_target = this.state.achieve_target
        ? this.state.achieve_target
        : (this.props.item.achieve_target ?? 0);
      payload.start_date = this.props.item.start_date;
      payload.end_date = this.props.item.end_date;
      payload.quarter_name = 'Q' + (this.props.mitIndex + 1);
      payload.offset_update = offsetUpdateValue;
      removeReactLoader();
      this.props.saveQuarterlyKR(payload, this.props.mitIndex);
      return Promise.resolve({ ...payload });
    }

		return goalService
			.addEditKr({ goalId: goalId, metric: payload })
			.then(res => {
				if (res && res.data?.data) {
					if (!this.props.onlyMetEdit && this.props.actions && this.props.actions.addNewKr) {

						if (!this.props.isChildKr && !this.props.fromParentKr) {
							this.props.actions.addNewKr(res.data.data);
						}
					}
				}
				removeReactLoader();
				console.log('payload', payload);
				const returnMetric = res?.data?.data;
				returnMetric.achieve_target = payload.achieve_target??0;
				console.log('returnMetric', returnMetric);
				return { ...payload, ...returnMetric};
			}).catch(() => {
				removeReactLoader();
			});
  }

  async onSaveWoboKpi(selectedKpi) {
    const metric = await this.handleSaveWoboKpi(selectedKpi);

    if (!metric) {
      return;
    }


    const dataSource = metric?.id ? await this.getDataSource(metric) : null;

    this.setState({
      achieve_target: metric?.achieve_target,
      externalSource: this.getCurrentExternalSource(metric),
      dataSource,
      measureType: metric?.metric,
      targetValue: metric?.target,
      kpiType: 'wobo_kpi',
      source: krdetailConstants.SOURCE_EXT_SOURCES,
      ext_app_id: krdetailConstants.WOBO_KPI_ID,
      external_app_sources: [{
        id: selectedKpi?.id,
        external_app_id: krdetailConstants.WOBO_KPI_ID,
        data: JSON.stringify({
          kpiId: selectedKpi?.id,
        })
      }],
      showModal: false,
    });
    if (this.props.updateSingleItem) {
      this.props.updateSingleItem(metric);
    }
  }

  getCurrentExternalSource = ( metric) => {
    metric = metric || this.props.item;
    if (!metric.external_app_sources || metric.external_app_sources.length === 0) {
      return null;
    }
    let externalSource = metric.external_app_sources[0] ? metric.external_app_sources[0] : metric.external_app_sources;
    externalSource = {...externalSource}; // Shallow copy the object

    if (typeof externalSource?.data === 'string') {
      externalSource.data = parseMetricExternalSourceData(externalSource.data);
    } else if (externalSource?.data && typeof externalSource.data === 'object') {
      externalSource.data = parseMetricExternalSourceData(externalSource.data);
    }
    return externalSource;
  }

  getDataSourceTargetForForm(extSource) {
    if (!extSource) {
      return undefined;
    }
    const fromKpiRow = getAutomatedTargetFromMetricData(extSource.kpiData?.data);
    if (fromKpiRow !== undefined) {
      return fromKpiRow;
    }
    return getAutomatedTargetFromMetricData(extSource.data);
  }

  /**
   * KPI / ext source payloads may use boolean true/false or string 'true'/'false' (PHP JSON).
   */
  normalizeAutomateTargetFlag(v) {
    if (v === true || v === 'true') {
      return true;
    }
    if (v === false || v === 'false') {
      return false;
    }
    return null;
  }

  getAutomateTargetFlagFromExternalData(data) {
    if (data == null) {
      return null;
    }
    let parsed = data;
    if (typeof data === 'string') {
      try {
        parsed = typeof $ !== 'undefined' && $.parseJSON ? $.parseJSON(data) : JSON.parse(data);
      } catch (e) {
        return null;
      }
    }
    if (typeof parsed !== 'object' || parsed === null) {
      return null;
    }
    if (!Object.prototype.hasOwnProperty.call(parsed, 'automateTargetFlag')) {
      return null;
    }
    return this.normalizeAutomateTargetFlag(parsed.automateTargetFlag);
  }

  getCurrentautomateTargetFlagForItem(item) {
    const src = item?.external_app_sources?.[0];
    if (!src?.data) {
      return null;
    }
    return this.getAutomateTargetFlagFromExternalData(src.data);
  }

  /**
   * Prefer explicit UI state; fall back to stored external source data (avoids null overwriting API boolean true).
   */
  resolveAutomateTargetFlagForValidation(extData, stateFlag) {
    if (stateFlag !== null && stateFlag !== undefined) {
      return !!stateFlag;
    }
    const fromExt = this.getAutomateTargetFlagFromExternalData(extData);
    return fromExt !== null ? fromExt : false;
  }

  resolveAutomateTargetFlagForPayload(currentExternalSource, stateFlag) {
    if (!currentExternalSource) {
      return false;
    }
    const fromData = this.getAutomateTargetFlagFromExternalData(currentExternalSource.data);
    if (stateFlag !== null && stateFlag !== undefined) {
      return !!stateFlag;
    }
    if (fromData !== null) {
      return fromData;
    }
    return false;
  }

  shouldShowAutomateTargetCheckbox() {
    const extAppId = Number(this.state.externalSource?.external_app_id ?? this.state.item?.ext_app_id);
    if (
      extAppId === krdetailConstants.JIRA_KPI_ID ||
      extAppId === krdetailConstants.AZURE_DEVOPS_KPI_ID
    ) {
      return false;
    }
    return krdetailConstants.KRS_AUTOMATE_TARGET.includes(String(extAppId));
  }

  getAutomatedTargetHelpText() {
    const { t } = this.props;
    const extAppId = Number(this.state.item?.ext_app_id);

    if (extAppId === krdetailConstants.JIRA_KPI_ID) {
      return t(
        'This target is set automatically from your Jira data source based on the total issue count in scope. To enter a target manually, click Change data source, reconnect to Jira, and uncheck Automate target value before saving.',
      );
    }
    if (extAppId === krdetailConstants.AZURE_DEVOPS_KPI_ID) {
      return t(
        'This target is set automatically from your Azure DevOps data source. To enter a target manually, click Change data source, reconnect to Azure DevOps, and turn off automate target before saving.',
      );
    }
    return t(
      'This target is updated automatically from your data source. Uncheck Automate Target Value to set the target manually.',
    );
  }

  renderAutomatedTargetHelp() {
    return (
      <HelpTextComp popUpClass="leftAlign" wrapperClass="committedKRHelpText marginL3">
        {this.getAutomatedTargetHelpText()}
      </HelpTextComp>
    );
  }

  async getDataSource(metric) {
    metric = metric || this.props.item;
    if (!metric.id) {
      return null;
    }
    const goalService = new GoalServices();
    const response = await goalService.getDataSource({ metricId: metric.id });
    let dataSource = response.data?.data?.dataSource?.extSource;
    if (typeof dataSource?.data === 'string') {
      dataSource.data = JSON.parse(dataSource.data);
    }
    return dataSource;
  }

  saveTag = (childData) =>{
    this.setState({tags:childData})
  }

  exitDeleteModal() {
    this.setState({ externalSrc: false });
  }

  saveKr() {
    const { t } = this.props;
    const uomChanged = parseInt(this.state.item.metric, 10) !== parseInt(this.state.measureType, 10);
    const intervalChanged = this.state.intervalType !== this.state.item.interval;
    const extAppId = Number(this.state.item?.ext_app_id ?? this.props.item?.ext_app_id);
    const isV2Integration = isExternalMetricV2AppId(extAppId);

    if (!this.state.lastSourceType || (!uomChanged && !intervalChanged)) {
      return this.saveData();
    }

    // v2: connector owns calculated values; UoM is display-only — no retain/purge prompt on UoM-only edits.
    const isWoboKpi = extAppId === Number(krdetailConstants.WOBO_KPI_ID);
    if ((isV2Integration || isWoboKpi) && uomChanged && !intervalChanged) {
      return this.saveData();
    }

    if (this.state.lastSourceType != this.props.item.source && this.state.lastSourceType == 1) {
      return this.setState({ externalSrc: true });
    }

    let titleRetain = '';
    let contentRetain = '';
    if (intervalChanged && uomChanged && !isV2Integration) {
      titleRetain = t('Save key result with new Unit of Measurement and Cadence');
      contentRetain = t('Are you sure you want to change the update frequency  and the unit of measurement of this key result?');
    } else if (uomChanged && !isV2Integration) {
      titleRetain = t('Save key result with new Unit of Measurement');
      contentRetain = t('Are you sure you want to change the unit of measurement of this key result?');
    } else if (intervalChanged) {
      titleRetain = t('Save key result with new Cadence');
      contentRetain = t('Are you sure you want to change the update frequency of this key result?');
    }

    return this.setState({ externalSrc: true, titleRetain, contentRetain });
  }

  saveData() {
    const {t} = this.props;
    const numberWithComma = /^(\.)?[0-9,-]+(\.\d{0,10})?$/;
    const onlyNumbers = /^[0-9]+$/;

    let startValue = this.state.startValue || 0;
    let targetValue = this.state.targetValue;
    let targetLowValue = this.state.targetLowerLimit;
    let targetHighValue = this.state.targetUpperLimit;
    let stretchValue = this.state.stretchValue;
    let dsMetricValue = this.state.dsMetricValue;
    let krText = this.props.krText.trim();
    let krNote = this.props.krNote.trim();
    let errors = {};
    let offsetUpdateValue = this.state.offsetUpdateValue;
    let offsetUpdateFlag = this.state.offsetUpdateFlag;
    this.isSaveCustom(this.state.customInputData)
    this.setState({isCustomSave:[]})

    if( this.state.isRequirdCustomOkr && this.state.isRequirdCustomOkr.length>0  ){
      errors["customokr"] = t(`Please enter required field`);
      this.setState({isCustomSave:this.state.isRequirdCustomOkr})
      return this.setState({ errors });
    }
    // in case a child kr, the page has two input with the same id. (bad practice)
    if (this.props.isChildKr && this.props.fromParentKr) {
      krText = document.querySelectorAll('#metric-name-text')[1]?.value;
      krNote = document.querySelectorAll('#metric-name-note')[1]?.value;
    }
    if (krText == '') {
      return this.props.showMetricNameErr();
    }

    if (!this.props.realOwner.id) {
      return this.props.showMetricOwnerErr();
    }

    // Validate realOwner using role flags
    if (this.props.realOwner && this.props.realOwner.id) {
      if (this.state.checkRolFlag) {
        if (this.props.item && this.props.item.is_real_owner_rol !== undefined && this.props.item.is_real_owner_rol) {
          errors['real_owner_validation'] = `${this.props.realOwner.name} has Read Only access and can't be assigned KRs`;
          this.props.showRolErr(true);
          return this.setState({ checkRolFlag: false, errors: errors });
        } else {
          errors['real_owner_validation'] = ''
          this.props.showRolErr(false);
        }
      } else{
        errors['real_owner_validation'] = ''
        this.props.showRolErr(false);
      }
    }

    if (!this.props.mitChildKr && (startValue === undefined || startValue == '' || !numberWithComma.test(startValue))) {
      return this.setState({error: t('Please enter a numeric value for start value.')})
    }
    if (offsetUpdateFlag && (offsetUpdateValue == '' || offsetUpdateValue === 'undefined')) {
      return this.setState({error: t('Enter the # of days (1-30) to offset collecting each update for this Key Result.')})
    }

    if (offsetUpdateFlag && offsetUpdateValue && (!onlyNumbers.test(offsetUpdateValue) || offsetUpdateValue > 30 || offsetUpdateValue < 1)) {
      return this.setState({error: t('Enter the # of days (1-30) to offset collecting each update for this Key Result.')})
    }

    if (this.state.isStretchEnabled) {
      if ((targetValue === undefined || targetValue === null  || targetValue == '' ) && (stretchValue === undefined || stretchValue == '')) {
        return this.setState({error: 'Please enter target value.'})
      }
      if (targetValue && !numberWithComma.test(targetValue)) {
        return this.setState({error: 'Please enter a numeric value'})
      }
      if (stretchValue && !numberWithComma.test(stretchValue)) {
        return this.setState({error: 'Please enter a numeric value'})
      }
      if ((dsMetricValue == 1 || dsMetricValue == 9) && stretchValue && stretchValue < targetValue) {
        return this.setState({error: 'Stretch target should be greater than committed'})
      }
      if ((dsMetricValue == 2 || dsMetricValue == 8) && stretchValue > targetValue) {
        return this.setState({error: 'Stretch target should be less than committed'})
      }
      if (dsMetricValue == 1 && (+startValue > +stretchValue || +startValue > +targetValue )) {
        return this.setState({error: 'Starting value should be lesser than commit and stretch'});
      }
      if (dsMetricValue == 2 && (+startValue < +stretchValue || +startValue < +targetValue )) {
        return this.setState({error: 'Starting value should be greater than commit and stretch'});
      }
    } else {
      if (dsMetricValue == 4) {
        if (targetLowValue === undefined || targetLowValue === '' || !numberWithComma.test(targetLowValue) ||
          !targetHighValue === undefined || targetHighValue === '' || !numberWithComma.test(targetHighValue)) {
          return this.setState({error: t('Please enter numeric for both target lower and upper.')});
        }

        if (+targetLowValue > +targetHighValue) {
          return this.setState({error: t('Lower limit is greater than upper limit')});
        }
      } else {
        let isTargetAutomate = this.resolveAutomateTargetFlagForValidation(
          this.state?.externalSource?.data,
          this.state.automateTargetFlag
        );
        if (!isTargetAutomate && (targetValue === undefined || targetValue == '' || !numberWithComma.test(targetValue))) {
          return this.setState({error: 'Please enter a numeric value for target value.'})
        }
      }
    }


    if (!this.state.isStretchEnabled && dsMetricValue == 1 && +startValue > +targetValue) {
      return this.setState({error: t('Starting value should be less than target')});
    }

    if (!this.state.isStretchEnabled && dsMetricValue == 2 && +startValue < +targetValue) {
      return this.setState({error: t('Starting value should be greater than target')});
    }

    if (dsMetricValue == 4) {
      if (targetLowValue === undefined || targetLowValue === '' || !numberWithComma.test(targetLowValue) ||
        !targetHighValue === undefined || targetHighValue === '' || !numberWithComma.test(targetHighValue)) {
        return this.setState({error: t('Please enter numeric for both target lower and upper.')});
      }

      if (+targetLowValue > +targetHighValue) {
        return this.setState({error: t('Lower limit is greater than upper limit')});
      }
    }
    if(this.state.lastSourceType != this.props.item.source  && !this.state.externalSrc && this.state.lastSourceType == 1){
      this.setState({
        externalSrc: true,
        titleRetain: "",
        contentRetain: "",
      })
    }else{

      let nlpIds =this.state.selectednlplTagsName && this.state.selectednlplTagsName.length ? this.state.selectednlplTagsName : ['']
      let tagids=this.state.tags.length ? this.state.tags : ['']
      let finalTagsIds = [...nlpIds,...tagids]

      offsetUpdateValue = offsetUpdateFlag ? +offsetUpdateValue : null;

      let payload = {
        id: this.state.item.id,
        name: krText,
        description: krNote,
        metric: this.state.measureType,
        initial_data: startValue,
        counting: dsMetricValue,
        interval: this.state.intervalType,
        source: this.props.item.source,
        parent: this.props.item.parent,
        ext_app_id: this.props.item.ext_app_id || this.state.item.ext_app_id,
        krTagIds: finalTagsIds,
        progress_consider: this.state.exclude ? 0 : 1,
        real_owner: this.props.realOwner ? this.props.realOwner.id : this.props.item.real_owner,
        owner: this.props.realOwner ? this.props.realOwner.id : this.props.item.real_owner,
        clearCache: true,
        offset_update: offsetUpdateValue,
      };
      payload.kr_duration=this.props.kr_duration;
      payload.isQuarter=this.props.isQuarter;
      if (!this.state.isStretchEnabled || this.state.dsMetricValue == 4) {
        payload.committed_target = this.state.committedKRFlag == 1 ? 1 : 0;
      }

      if (this.props.item?.kpiDataId) {
        payload.kpiDataId = this.props.item.kpiDataId;
      }

      if (this.props.item?.clientId) {
        payload.clientId = this.props.item.clientId;
      }

      if (this.props.item?.isNew) {
        payload.isNew = this.props.item.isNew;
      }

      if (this.props.item?.kpiId) {
        payload.kpiId = this.props.item.kpiId;
      }

      if (this.props?.coOwners) {
        payload.coOwners = this.props.coOwners.length > 0 ? Array.prototype.map
        .call(this.props.coOwners, s => s.id)
        .toString() : '';
      }
      // adding start and end date
      if(this.props.item.parent){
        payload.start_date = this.props.childKrDuration.start ;
        payload.end_date = this.props.childKrDuration.end;
      }
      payload["nested_krs"] = constructNestedKRPayload(this.props);
      let teaMperArr = [], bizPerArr = [];
      if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
        const { permission_teams = [], permission_biz = []} = this.props.goalDetails;
        if (Array.isArray(permission_teams) && permission_teams.length) {
          teaMperArr = permission_teams.map(val => val.id);
        }
        if (Array.isArray(permission_biz) && permission_biz.length) {
          bizPerArr = permission_biz.map(val =>val.id);
        }
      } else {
        teaMperArr = this.state.teamPermissionSelected.map(val => val.id);
        bizPerArr = this.state.bizPermissionSelected.map(val => val.id);
      }
      payload.permission_teams = teaMperArr;
      payload.permission_biz = bizPerArr;

      if (this.props.goalDetails && this.props.goalDetails.all_metrics == 1) {
        payload.permission = this.props.goalDetails.permission;
      } else {
        payload.permission = Array.prototype.map
          .call(this.state.permissionstate, s => s)
          .toString(); // "A,B,C";
      }

      let automatedTargetValue = null;
      let externalData = null;
      const currentExternalSource = this.getCurrentExternalSource() || this.state.externalSource;
      if (currentExternalSource) {
        const projectObj = {
          name: currentExternalSource.ext_app_link_name,
          id: currentExternalSource.ext_app_link_id,
          type: currentExternalSource.ext_app_link_type
        }
        const resolvedAutomateTargetFlag = this.resolveAutomateTargetFlagForPayload(
          currentExternalSource,
          this.state.automateTargetFlag
        );
        externalData = buildEditExtSourceData({
          storedSourceData: parseMetricExternalSourceData(currentExternalSource.data),
          automateTargetFlag: resolvedAutomateTargetFlag,
          kpiDataIdFallback: this.props.item?.kpiDataId,
        });

        if (resolvedAutomateTargetFlag && typeof externalData.total !== 'undefined') {
          automatedTargetValue = externalData.total;
        }

        const externalSourceForPayload = buildExternalSourceForPayload(
          currentExternalSource,
          externalData,
        );

        payload = {
          ... payload,
          ... {
            instance_url: currentExternalSource.instance_url,
            project_ids: [JSON.stringify(projectObj)],
            ext_source_data: externalData,
            external_app_sources : externalSourceForPayload,
            ext_source_unit: {
              metric: this.state.metricType,
              progress: externalData.value,
              target: externalData.total || this.props.item?.target
            }
          }
        }
        payload.kr_duration = this.props.kr_duration;
        payload.isQuarter = this.props.isQuarter;
      }
      if (this.state.intervalType == 2 || this.state.intervalType == 6) {
        payload.weekly_update_day = this.state.dayType;
      }
      if (dsMetricValue == 4) {
        payload.lower_limit = targetLowValue;
        payload.upper_limit = targetHighValue;
      } else {
        payload.target = automatedTargetValue !== null ? automatedTargetValue : targetValue;
        payload.progress_type = this.state.progType;
        if (this.state.isStretchEnabled) {
          payload.stretchTarget = stretchValue;
        }
      }

      if (this.props.isChildKr && this.props.fromParentKr) {
        payload.start_date = this.props.childKrDuration?.start ;
        payload.end_date = this.props.childKrDuration?.end;
      } else if (this.props.kr_duration?.isCustom === true || this.props.kr_duration?.isCustom === 'true') {
        if (this.props.kr_duration?.start && this.props.kr_duration?.end) {
          payload.start_date = this.props.kr_duration.start;
          payload.end_date = this.props.kr_duration.end;
        }
      }
      payload.retainUpdates =  this.state.selectedTypeOpt ? this.state.selectedTypeOpt : '' ;
      const goalId = resolveKrSaveGoalId(this.state.item, this.props.goalDetails || this.props.addOkrData?.goalDetails);
      if (this.state.item.cascade_goal_id) {
        payload.cascade_goal_id = this.state.item.cascade_goal_id;
      }
      if(this.props.mitChildKr){
        const dsProgress =
          this.state.dataSource?.kpiData?.data?.value ??
          this.state.dataSource?.data?.value;
        payload.achieve_target = this.state.achieve_target
          ? this.state.achieve_target
          : (externalData?.value ?? dsProgress ?? this.props.item?.achieve_target ?? 0);
        payload.end_date = this.props.item.end_date;
        payload.start_date = this.props.item.start_date;
        payload.quarter_name =  'Q'+(this.props.mitIndex+1);
        // Ensure offset_update is explicitly included in the payload
        payload.offset_update = offsetUpdateValue;
        this.props.saveQuarterlyKR(payload, this.props.mitIndex);
        this.props.closeKrRightPane(true);
      } else {
        let { actions } = this.props;
        const goalService = new GoalServices();

        payload.isQuarter  =this.props.isQuarter;
        payload.kr_duration =this.props.kr_duration;
        payload.customField = JSON.stringify(this.props.customFieldsData);
        reactLoader();
        goalService.addEditKr({ goalId: goalId, metric: payload }).then(
          response => {
            this.setState({ error: "" });
            removeReactLoader();
            if (response.data) {
              let result = response.data.data;
              if (this.props.isChildKr && this.props.fromParentKr) {
                result.duration = this.props.childKrDuration;
                result.coOwnersDetails = this.props.coOwners?.length > 0 ? coOwners : [];
                this.props.saveNestedKr(result, this.props.nestedKrIndex, this.props.nestedKrAction);
              } else if(this.props.mitChildKr){
                this.props.saveQuarterlyKR(result, this.props.mitIndex);
                this.props.closeKrRightPane(true);
              } else if (!this.props.onlyMetEdit) {
                actions?.editNewKr(this.state.item.id, result);
              }
              this.props.closeKrRightPane(true);
            }
          }
        ).catch(error => {
          this.setState({ error: error.message });
          removeReactLoader();
        });
      }
    }
  }

  setRightPaneValue() {
    this.props.closeKrRightPane(true);
  }

  getCurrentDayType() {
    return this.props.item && this.props.item.weekly_update_day ? this.props.item.weekly_update_day : 5;
  }

  getCurrentIntervalType() {
    if (this.props.item && this.props.item.interval) {
      return this.props.item.interval != 0 ? this.props.item.interval : 2;
    }

    if (this.props.basicInlineData && this.props.basicInlineData.interval) {
      return this.props.basicInlineData.interval != 0 ? this.props.basicInlineData.interval : 2;
    }

    return 2;
  }

  getCurrentMetricValue() {
    return (this.props.item && parseInt(this.props.item.counting)) ? parseInt(this.props.item.counting) : 1;
  }

  getCurrentCommittedFlag() {
    return this.props.item && this.props.item.committed_target != null ? this.props.item.committed_target : 0;
  }

  getCurrentExclude() {
    return this.props.item && (this.props.item?.progress_consider == '0' || this.props.item?.progress_consider == 'false') ? 1 : 0;
  }

  getCurrentautomateTargetFlag() {
    return this.getCurrentautomateTargetFlagForItem(this.props.item);
  }

  getCurrentOffsetUpdateFlag() {
    return this.props.item && (this.props.item?.offset_update != null && this.props.item?.offset_update != '') ? true : false;

  }

  getCurrentOffsetUpdateValue() {

    return this.props.item && this.props.item?.offset_update != null ? this.props.item.offset_update : null;
  }

  getCurrentProgressType() {
    return this.props.item && this.props.item.progress_type ? this.props.item.progress_type : 1;
  }

  getCurrentTargetValue() {
    let isStretchEnabled = this.props.addOkrData && this.props.addOkrData.isStretchEnabled
                           ? this.props.addOkrData.isStretchEnabled
                           : this.props.goalDetails && this.props.goalDetails.isStretchEnabled
                           ? this.props.goalDetails.isStretchEnabled
                           : false;
    let committedKRFlag = this.props.item && this.props.item.committed_target != null
                          ? parseInt(this.props.item.committed_target) : 0;
    if ((!isStretchEnabled && this.props.item && this.props.item.target) ||
        (isStretchEnabled && this.props.item && this.props.item.stretch_target !== null) ||
        (isStretchEnabled && committedKRFlag && this.props.item && this.props.item.stretch_target == null)
    ) {
        if (this.props.item.progress === null && this.props.item.metric != 3) {
          if (isKpiIframeMetricTargetApp(Number(this.props.item.ext_app_id))) {
            return this.props.item.target;
          }
          return null;
        }
        return this.props.item.target;
    }

    if (this.props.basicInlineData && this.props.basicInlineData.target) {
      return this.props.basicInlineData.target;
    }
  }

  getCurrentStretchValue() {
    let isStretchEnabled = this.props.addOkrData && this.props.addOkrData.isStretchEnabled
                           ? this.props.addOkrData.isStretchEnabled
                           : this.props.goalDetails && this.props.goalDetails.isStretchEnabled
                           ? this.props.goalDetails.isStretchEnabled
                           : false;
    let committedKRFlag = this.props.item && this.props.item.committed_target != null
                          ? parseInt(this.props.item.committed_target) : 0;
    if (this.props.item && this.props.item.stretch_target !== null) {
      return this.props.item.stretch_target;
    } else if (isStretchEnabled && this.props.item && this.props.item.target && !committedKRFlag) {
      return this.props.item.target;
    } else if (isStretchEnabled && this.props.basicInlineData && this.props.basicInlineData.target) {
      return this.props.basicInlineData.target;
    }
  }

  getCurrentStartValue() {
    if (this.props.item && this.props.item.initial_data !== undefined && this.props.item.initial_data !== '') {
      return this.props.item.initial_data;
    }

    if (this.props.basicInlineData && this.props.basicInlineData.initial_data !== undefined && this.props.basicInlineData.initial_data !== '') {
      return this.props.basicInlineData.initial_data;
    }

    return '0';
  }

  getCurrentMeasureType() {
    if (this.props.item && this.props.item.metric) {
      if (this.props.item.ext_app_id === '29' && this.props.item.target === '100') return 3;

      return (this.props.item.metric == 4 || this.props.item.metric == 0) ? 1 : this.props.item.metric;
    }

    if (this.props.basicInlineData && this.props.basicInlineData.metric) {
      return this.props.basicInlineData.metric;
    }

    return 1;
  }

  handleResultValueChange(e) {
    e.preventDefault();
    const newDsMetricValue = e.target.value;

    // Check if it's monday.com and has automated target
    if ((this.state.dataSource?.app_id == '39' || this.state.dataSource?.app_id == '44') && this.state.automateTargetFlag) {
      // Set targetValue to dataSource.kpiData.data.total if available
      const newTargetValue = this.state.dataSource?.kpiData?.data?.total || undefined;
      this.setState({
        dsMetricValue: newDsMetricValue,
        targetValue: newTargetValue
      });
    } else {
      this.setState({dsMetricValue: newDsMetricValue});
    }
  }

  handleMeasurValueChange(e) {
    e.preventDefault();
    this.setState({measureType: e.target.value })
  }


  handleDayTypeValueChange(e) {
    e.preventDefault();
    this.setState({dayType: e.target.value});
  }

  handleIntervalValueChange(e) {
    e.preventDefault();
    this.setState({intervalType: e.target.value});
  }

  handleProgressTypeChange(e) {
    e.preventDefault();
    this.setState({ progType: e.target.value });
  }

  handleCommittedKRChange() {
    this.setState({ committedKRFlag: this.state.committedKRFlag == 1 ? 0 : 1 });
  }

  handleAutomateTargetFlagChange() {
    this.setState({ automateTargetFlag: this.state.automateTargetFlag  ? false : true });
  }

  permissionData(perData) {
		this.setState({
			permissionstate: perData
		});
	}

	teamPermissionData(teamPerData) {
		this.setState({
			teamPermissionSelected: teamPerData
		});
	}

	bizPermissionData = (bizPerData) => {
    this.setState({
      bizPermissionSelected: bizPerData
    });
  }

  isSaveCustom(isVal){
    let arr=[];
    let j=0;
    let keyArrCategory=[]
    let valArray = []
    isVal && Object.keys(isVal).forEach((v)=>{
      j++;
      isVal[v]["customFields"]&&
      Object.keys(isVal[v]["customFields"]).forEach(objv=>{
        keyArrCategory.push(objv)
        if(isVal[v]["customFields"][objv]['is_required']=='1'
        &&( isVal[v]["customFields"][objv]["text"]  ==undefined || isVal[v]["customFields"][objv]["text"]  ==[])
        ){
             arr.push(objv,v)
            }
        if(isVal[v]["customFields"][objv]["text"]){
          valArray.push(isVal[v]["customFields"][objv]["text"])
        }else{
          valArray.push('')
            }
      })
      if(j==Object.keys(isVal).length){
        this.setState({isRequirdCustomOkr:[...arr]})
      }
      let finalDataArray=[]
      for(let i=0;i<valArray.length;i++){
        if(Array.isArray(valArray[i])){
          valArray[i].forEach(val => {
            finalDataArray.push({id:keyArrCategory[i],val:val.name,object_type:'6'})
          })
        }
        else{
          finalDataArray.push({id:keyArrCategory[i],val:valArray[i],object_type:'6'})
        }

      }
    })

  }

  isRequiredCustomOkrFiled(isVal,id){
    let cust_id=this.state.isCustomSave.find((u) => u == id);
    let ar=this.state.isCustomSave ? this.state.isCustomSave:'';
    let fr= ar.filter(
        (u) => u != cust_id
      )
    this.setState({isCustomSave:fr})
    this.isSaveCustom(isVal)
    this.setState({customInputData:isVal})
  }

  renderError(field) {
    return (
      <ErrorTextComp key={field} errors={this.state.errors} field={field} />
    );
  }

  updateTags(Newtags){
    this.setState({
      selectednlplTagsName: Newtags
    })
  }

  changeRadioOpt(value) {
		const valueToSet = value
		this.setState(
		  {
        selectedTypeOpt: valueToSet
		  }
		)
	}
  saveItems(){
    if(this.state.externalSrc){
      // Close the retain update modal before saving
      this.setState({ externalSrc: false });
      this.saveData();
    }
  }

  getDsMetric = (dsMetric) => {
    const {t} = this.props;
    const dict = {
      1: "Should increase to",
      2: "Should decrease to",
      3: "Should be equal to",
      4: "Should fall within a range",
      8: "Should not exceed",
      9: "Should not fall below"
    }
    return dict[dsMetric];
  }

  handleExcludeChange() {
    this.setState({ exclude: this.state.exclude == 1 ? 0 : 1 });
  }

  handleOffsetUpdateFlagChange = (e) => {
    this.setState({ offsetUpdateFlag: e.target.checked ? true : false });
    if (e.target.checked) {
      this.setState({ offsetUpdateValue: 1 });
    }
  };

  handleOffsetUpdateValueChange = (e) => {
    const value = Number(e.target.value) ? Number(e.target.value) : e.target.value;
    this.setState({ offsetUpdateValue: value });
  };

  render() {
    let popUp = null;
    const isWoboKpi = this.shouldUseWoboKpiSearchModal();
    if (this.state.showModal) {
      const initialKpi = this.state.dataSource?.data?.id && {
        id: this.state.dataSource?.data?.id,
        name: this.state.dataSource?.data?.name,
      };
      popUp = isWoboKpi ? (
        <KpiSearchModal
          initialValue={initialKpi}
          onSave={this.onSaveWoboKpi}
          onClose={this.closePopup}
        />
      ) :
      (
        <KpiMarketPlaceKrWizardPopup
          {...this.props }
          closePopUp={this.closePopup}
          saveKrComplete={this.handleSaveComplete}
        />
      );
    }
    const isRally = this.state?.item?.ext_app_id ? this.state.item.ext_app_id == krdetailConstants.RALLY_APP_ID : false;
    const {t} = this.props;
    const isNoCurrency= this.state?.item?.ext_app_id ? krdetailConstants.KRS_NO_CURRENCY.includes(this.state.item.ext_app_id) : false;
    const isTargetAutomate = this.resolveAutomateTargetFlagForValidation(
      this.state?.externalSource?.data,
      this.state.automateTargetFlag
    );
    const isOffsetUpdateEnabled = window.wbConfig.isOffsetUpdateEnabled ?? false;

    return (
      <ThemeProvider>
        <div className="okrSalesforceIntegration dataStreamSource">
          { this.state.showModal && <div className="salesforceIntegrationPopup">{popUp}</div> }
          { this.state.isSelected && this.state.item && this.state.item.external_app_sources &&
            <div className="salesforceSelectedExternalSources">
              <div className="salesforceSelectedLabel">{t('Selected Data Source')}</div>
              <div className="salesforceSourceWrapper">
                { !this.state.dataSource && <div className="verticalTop inLineBlk" style={{minWidth: '51%', padding: '14px'}}>Loading data source ...</div>}
                { this.state.dataSource && typeof this.state.achieve_target !== 'undefined' &&
                  <KpiDataSourceComponent
                    dataSource={this.state.dataSource}
                    data={this.state.dataSource.data}
                    metricId={this.state.item.id}
                    achieveTarget={this.state.achieve_target}
                    showIcon={false}
                  />
                }
                <div className="verticalTop inLineBlk">
                  <ButtonComp
                    buttonWrapperClass="change-other-option"
                    buttonClick={() => this.setState({ showModal: true})}
                    label="Change data source"
                    iconClass="icon icon-outline-edit-24px-blue"
                    addEditFlag={this.props.addEditFlag}
                  />
                </div>
              </div>
            </div>
          }
          { this.state.item &&  (this.state.item.id || this.props.mitChildKr) &&
            <div className="basickrModal">
              {
                this.state.error && this.state.error !== '' && <div className="basicKrError">{ this.state.error }</div>
              }
              <form onSubmit={this.saveKr}>
                <div className="basickrstarttargets">
                  <div className="verticalTop inLineBlk">
                    <Textfield
                      className="basicKrInfoInput"
                      value={this.state.startValue}
                      style={{ width: '58px' }}
                      label={t("Start value")}
                      isRequired={true}
                      placeholder="0"
                      type="type"
                      onChange={(e) => this.setState({ startValue: e.target.value})}
                    ></Textfield>
                  </div>
                  <div className="verticalTop inLineBlk">
                    <InputLabel className="basicKrInfoSelectLabel" htmlFor="dsMetricSelection">{t('Result Value')}</InputLabel>
                    {this.props.mitChildKr ?
                    <div className='ds-metric-type basicKrInfoSelect'>{this.getDsMetric(this.state.dsMetricValue)}</div>
                      :
                    <MatSelect className="basicKrInfoSelect" style={{width: '205px'}}
                      native
                      value={this.state.dsMetricValue}
                      onChange={this.handleResultValueChange}
                      inputProps={{ name: 'Result Value', id: 'dsMetricSelection' }}
                      >
                        <option value={1}>{t('Should increase to')}</option>
                        <option value={2}>{t('Should decrease to')}</option>
                        <option value={3}>{t('Should be equal to')}</option>
                        <option value={4}>{t('Should fall within a range')}</option>
                        <option value={8}>{t('Should not exceed')}</option>
                        <option value={9}>{t('Should not fall below')}</option>
                    </MatSelect>
                    }
                  </div>
                  { !this.state.isStretchEnabled &&
                    this.state.dsMetricValue != 4 && !isTargetAutomate &&
                    <div className="verticalTop inLineBlk">
                      <Textfield
                        className="basicKrInfoInput"
                        value={this.state.targetValue}
                        style={{ width: '74px' }}
                        label={t("Target value")}
                        isRequired={true}
                        placeholder="0"
                        type="type"
                        onChange={(e) => this.setState({ targetValue: e.target.value})}
                      ></Textfield>
                    </div>
                  }

                  { !this.state.isStretchEnabled && this.state.dsMetricValue != 4 && isTargetAutomate &&
                    <div className="verticalTop inLineBlk">
                      <div className="dsTextLabel target-text-bold marginB5 widthFitContent">
                        {t('Target value')}<span className="text-style-1">*</span>
                        {this.renderAutomatedTargetHelp()}
                      </div>
                      <Textfield
                        className="basicKrInfoInput"
                        value={this.state.targetValue}
                        style={{width: '95px', border:'0', backgroundColor: 'white'}}
                        isRequired={true}
                        placeholder="Enter Value"
                        type="text"
                        disabled={true}
                      ></Textfield>
                    </div>
                  }
                   { this.state.isStretchEnabled &&
                    this.state.dsMetricValue != 4 && !isTargetAutomate && (
                      <div className="verticalTop inLineBlk marginT22">
                        <div className="dsTextLabel target-text-bold">
                          {t('Target value')}<span className="text-style-1">*</span>
                        </div>
                        <div className="metric-target-text marginB5 widthFitContent">
                          {t('Committed target')}
                          <HelpTextComp popUpClass="leftAlign" wrapperClass="committedKRHelpText marginL3">
                            {t('When you set a Committed Result, the RAG status will follow a more aggressive curve throughout the quarter, and your progress at the end of the quarter will only be green if you achieve 100% of your target.')} {t('This is helpful for financial targets, SLAs, or similar targets that you have a commitment to hit.')}
                          </HelpTextComp>
                        </div>

                        <Textfield
                          className="basicKrInfoInput"
                          value={this.state.targetValue}
                          style={{ width: '95px' }}
                          placeholder="Enter Value"
                          type="type"
                          onChange={(e) => this.setState({ targetValue: e.target.value})}
                        ></Textfield>
                      </div>
                    )}
                  { this.state.isStretchEnabled && this.state.dsMetricValue != 4 && isTargetAutomate &&
                    <div className="verticalTop inLineBlk marginT22" >
                      <div className="dsTextLabel target-text-bold">
                          {t('Target value')}<span className="text-style-1">*</span>
                          {this.renderAutomatedTargetHelp()}
                        </div>
                        <div className="metric-target-text marginB5 widthFitContent">
                          {t('Committed target')}
                          <HelpTextComp popUpClass="leftAlign" wrapperClass="committedKRHelpText marginL3">
                            {t('When you set a Committed Result, the RAG status will follow a more aggressive curve throughout the quarter, and your progress at the end of the quarter will only be green if you achieve 100% of your target.')} {t('This is helpful for financial targets, SLAs, or similar targets that you have a commitment to hit.')}
                          </HelpTextComp>
                      </div>
                      <Textfield
                        className="basicKrInfoInput"
                        value={this.state.targetValue}
                        style={{width: '95px', border:'0', backgroundColor: 'white'}}
                        placeholder="Enter Value"
                        type="text"
                        disabled={true}
                      ></Textfield>
                    </div>
                  }
                  { this.state.dsMetricValue != 4 && this.state.isStretchEnabled &&  !this.state.automateTargetFlag && (
                      <div className="verticalTop inLineBlk" >
                        <div className="metric-target-text marginB5 widthFitContent">
                          {t('Stretch target')}
                          <HelpTextComp popUpClass="leftAlign" wrapperClass="committedKRHelpText marginL3">
                            {t('Aim for best possible! Your stretch target is what you aspire to achieve beyond what has been committed')}
                          </HelpTextComp>
                        </div>
                        <Textfield
                          className="basicKrInfoInput"
                          value={this.state.stretchValue}
                          style={{width: '100px'}}
                          placeholder="Enter value"
                          type="text"
                          onChange={(e) => this.setState({ stretchValue: e.target.value})}
                        ></Textfield>
                      </div>
                    )}
                  { this.state.dsMetricValue != 4 && this.shouldShowAutomateTargetCheckbox() &&
                    <div className="verticalTop inLineBlk"  style={{marginTop: `30px`, width: '185px'}}>
                      <div className="basicKrInfoInput">
                        <input
                          id="automateTargetFlag"
                          type="checkbox"
                          name="automateTargetFlag"
                          className="committedKRInput"
                          defaultChecked={this.state.automateTargetFlag}
                          onChange={this.handleAutomateTargetFlagChange}
                        />
                        <label htmlFor="automateTargetFlag" />
                        <span className="basicKrInfoInput">{t('Automate Target Value')}</span>
                      </div>
                    </div>
                  }
                  {
                    this.state.dsMetricValue == 4 && (
                      <div className="verticalTop inLineBlk">
                        <Textfield
                          className="basicKrInfoInput"
                          value={this.state.targetLowerLimit}
                          style={{ width: '118px' }}
                          label={t("Target lower limit")}
                          isRequired={true}
                          placeholder="0"
                          type="type"
                          onChange={(e) => this.setState({ targetLowerLimit: e.target.value})}
                        ></Textfield>
                        <Textfield
                          className="basicKrInfoInput"
                          value={this.state.targetUpperLimit}
                          style={{ width: '118px' }}
                          label={t("Target upper limit")}
                          isRequired={true}
                          placeholder="0"
                          type="type"
                          onChange={(e) => this.setState({ targetUpperLimit: e.target.value})}
                        ></Textfield>
                      </div>
                    )
                  }
                  {
                  (!this.state.isStretchEnabled && (this.props.addOkrData.showCommittedTarget || this.props.comingFromTest) && !this.props.mitChildKr) &&
                    <div className="committedKRWrapper inLineBlk">
                      <input
                        id="committedKR"
                        type="checkbox"
                        name="committedKR"
                        className="committedKRInput"
                        defaultChecked={this.state.committedKRFlag == 1 ? true : false}
                        onChange={this.handleCommittedKRChange}
                      />
                      <label htmlFor="committedKR" />
                      <span className="committedKRLabel">{t('Committed Result')}</span>
                      <HelpTextComp popUpClass="leftAlign" wrapperClass="committedKRHelpText marginL3">
                        {t('When you set a Committed Result, the RAG status will follow a more aggressive curve throughout the quarter, and your progress at the end of the quarter will only be green if you achieve 100% of your target.')} {t('This is helpful for financial targets, SLAs, or similar targets that you have a commitment to hit.')}
                      </HelpTextComp>
                    </div>
                  }
                </div>

                <div className="basickrstarttargets">
                  {(!this.props.mitChildKr) &&
                    <div className="verticalTop inLineBlk">
                      <InputLabel className="basicKrInfoSelectLabel" htmlFor="measureTypeSelection">{t('Unit of Measurement')}</InputLabel>
                      <MatSelect className="basicKrInfoSelect" style={{width: '205px'}}
                        native
                        value={this.state.measureType}
                        onChange={this.handleMeasurValueChange}
                        inputProps={{ name: 'Result Value', id: 'measureTypeSelection' }}
                        disabled={this.state?.item?.ext_app_id == krdetailConstants.MONDAY_KPI_ID ||
                                  this.state?.item?.ext_app_id == krdetailConstants.WRIKE_KPI_ID ||
                                  (this.state?.item?.ext_app_id == krdetailConstants.MS_PLANNER_KPI_ID &&
                                   this.state.dataSource?.data?.dataType === 'percent')}
                        >
                          <option value={1}>{t('Count as number')}</option>
                          {!isNoCurrency && (<option value={2}>{t('Count as currency')}</option>)}
                          <option value={3}>{t('Count as percentage')}</option>
                      </MatSelect>
                    </div>
                  }
                  { this.props.mitChildKr && isOffsetUpdateEnabled && (
                    <div className="basickrstarttargets">
                      <div className="verticalTop inLineBlk">
                        <input
                          id="offsetUpdateFlag"
                          type="checkbox"
                          name="offsetUpdateFlag"
                          className="committedKRInput"
                          defaultChecked={this.state.offsetUpdateFlag}
                          onChange={this.handleOffsetUpdateFlagChange}
                        />
                        <label htmlFor="offsetUpdateFlag" />
                        <span className="committedKRLabel">{t('Offset Update')}</span>
                        <HelpTextComp popUpClass="leftAlign" wrapperClass="committedKRHelpText marginL3" style={{marginTop: '-6px'}}>
                          {t('Enter the # of days (1-30) to offset collecting each update for this Key Result.')}
                        </HelpTextComp>
                        { this.state.offsetUpdateFlag && (
                          <div className="verticalTop inLineBlk">
                            <Textfield
                              min="1"
                              max="30"
                              id="daysInput"
                              type="type"
                              style={{ width: '54px', marginRight: '10px', marginTop: '-22px' }}
                              value={this.state.offsetUpdateValue}
                              className="basicKrInfoInput"
                              defaultValue = "1"
                              onChange={(e) => {
                                  this.setState({ offsetUpdateValue: e.target.value})
                              }}

                            />
                            <span style={{ display: 'inline-block', verticalAlign: 'top', marginTop:'-12px' }} htmlFor="daysInput">{t('day(s)')}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  <div className="verticalTop inLineBlk">
                    <InputLabel className="basicKrInfoSelectLabel" htmlFor="measureProgressSelection">{t('Calculate overall progress as')}</InputLabel>
                    <MatSelect className="basicKrInfoSelect" style={{width: '205px'}}
                      native
                      value={this.state.progType}
                      onChange={this.handleProgressTypeChange}
                      inputProps={{ name: 'Result Value', id: 'measureProgressSelection' }}
                      >
                        <option value={1}>{t('Last Entered Value')}</option>
                        <option value={2}>{t('Total of all entered values')}</option>
                        <option value={3}>{t('Average of all entered values')}</option>
                    </MatSelect>
                  </div>
                </div>
                {!this.props.mitChildKr &&
                (
                  <div className="basickrstarttargets">
                    <div style={{ marginBottom: '-20px'}}>
                      <InputLabel className="basicKrInfoSelectLabel inLineBlk">{t('Update cadence')}</InputLabel>
                    </div>
                    <div className="verticalTop inLineBlk">
                      <MatSelect className="basicKrInfoSelect" style={{width: '118px'}}
                        native
                        value={this.state.intervalType}
                        onChange={this.handleIntervalValueChange}
                        inputProps={{ name: 'intervalType', id: 'intervalSelection' }}
                        >
                          <option value={1}>{t('Daily')}</option>
                          <option value={2}>{t('Weekly')}</option>
                          <option value={3}>{t('Monthly')}</option>
                          <option value={4}>{t('Quarterly')}</option>
                          <option value={6}>{t('Bi-Weekly')}</option>
                      </MatSelect>
                    </div>
                    { (this.state.intervalType == 2 || this.state.intervalType == 6) && <div className="verticalTop inLineBlk" style={{ paddingTop: '28px'}}> {t('On')}</div>}
                    { (this.state.intervalType == 2 || this.state.intervalType == 6) && <div className="verticalTop inLineBlk">
                        <MatSelect className="basicKrInfoSelect" style={{width: '118px'}}
                          native
                          value={this.state.dayType}
                          onChange={this.handleDayTypeValueChange}
                          inputProps={{ name: 'dayType', id: 'dayTypeSelection' }}
                          >
                            <option value={1}>{t('Monday')}</option>
                            <option value={2}>{t('Tuesday')}</option>
                            <option value={3}>{t('Wednesday')}</option>
                            <option value={4}>{t('Thursday')}</option>
                            <option value={5}>{t('Friday')}</option>
                            <option value={6}>{t('Saturday')}</option>
                            <option value={7}>{t('Sunday')}</option>
                        </MatSelect>
                      </div>
                    }
                  { isOffsetUpdateEnabled && (
                    <div className="verticalTop inLineBlk" style={{ float: 'right', marginRight: '20px', paddingTop: '28px' }}>
                      <input
                        id="offsetUpdateFlag"
                        type="checkbox"
                        name="offsetUpdateFlag"
                        className="committedKRInput"
                        defaultChecked={this.state.offsetUpdateFlag}
                        onChange={this.handleOffsetUpdateFlagChange}
                      />
                      <label htmlFor="offsetUpdateFlag" />
                      <span className="committedKRLabel">{t('Offset Update')}</span>
                      <HelpTextComp popUpClass="leftAlign" wrapperClass="committedKRHelpText marginL3" style={{marginTop: '-6px'}}>
                        {t('Enter the # of days (1-30) to offset collecting each update for this Key Result.')}
                      </HelpTextComp>
                      { this.state.offsetUpdateFlag && (
                        <div className="verticalTop inLineBlk">
                          <Textfield
                            min="1"
                            max="30"
                            id="daysInput"
                            type="type"
                            style={{ width: '54px', marginRight: '10px', marginTop: '-22px' }}
                            value={this.state.offsetUpdateValue}
                            className="basicKrInfoInput"
                            defaultValue = "1"
                            onChange={(e) => {
                                this.setState({ offsetUpdateValue: e.target.value})
                            }}

                          />
                          <span style={{ display: 'inline-block', verticalAlign: 'top', marginTop:'-12px' }} htmlFor="daysInput">{t('day(s)')}</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
                )
              }

               {(this.props.customData && Object.keys(this.props.customData).length > 0 && !this.props.mitChildKr ) && <div className="krBreak" style={{marginBottom:"-10px"}} aria-hidden="true" />}
            {  ((this.props.addOkrData.groupKRCustomFields|| this.props.groupKRCustomFields) && !this.props.mitChildKr )&&
                  <Customokr
                    customData={this.props.customData}
                    isRequiredCustomOkrFiled={this.isRequiredCustomOkrFiled}
                    onCustomDataChange={(newData) => this.props.onCustomFieldsChange?.(newData)}
                    customFiledRequired={true}
                    renderError={this.renderError}
                    isCustomSave={this.state.isCustomSave}
                  />
            }

                {(this.props.addOkrData.display_nested_kr &&
                  !this.props.isChildKr && !this.props.mitChildKr &&
                  Math.ceil(moment(this.props.goalDetails.target_date).diff(moment(this.props.goalDetails.start_date), "days", true)) >= 360) &&
                  <NestedInlineComp
                  {...this.props}
                  actions = {this.props.actions}
                  nested_krs = {this.props.nested_krs}
                  updateNestedKrs = {this.props.updateNestedKrs}
                  />
                }

                <AddFinancialTargetsButton objectType="kr" objectId={this.props.item?.id} ownerUserId={this.props.realOwner?.id} />
                { !this.props.mitChildKr && <KrRelationshipWrapper {...this.props} metric={this.props.item} saveKr={this.saveKr}/>}
                {
                  !this.props.mitChildKr &&
                  <>
                    <AddKrTag metric={this.props.item} goalId={this.state.item.goal_id} taghandler={this.saveTag}
                      nplTags={this.state.nplTags}  selectednlplTags={this.state.selectednlplTags} selectednlplTagsName={this.state.selectednlplTagsName} updateTags={this.updateTags} tagsList={this.state.tagsList} searchText={this.props.krText}
                    />
                    <div className="fieldcontent ">
                      <input
                        id="exclude"
                        type="checkbox"
                        name="exclude"
                        className="committedKRInput"
                        defaultChecked={this.state.exclude == 1 ? true : false}
                        onChange={this.handleExcludeChange}
                      />
                      <label htmlFor="exclude" />
                      <span className="committedKRLabel">{t(`Exclude from objective progress calculation`)}</span>
                    </div>
                  </>
                }
                {this.props.goalDetails && this.props.goalDetails.all_metrics == "0" && !this.props.mitChildKr ? (
									<div className="pT10">
										<div className="viewPermissionArea">
											<span>
												{t('View permissions in addition to')}{" "}
												{this.props.goalDetails.type == 1 ? ` ${t('team')} ` : ` ${t('owner')} `}
												<div className="metricTargetHelptext permissionHelpText"
													onMouseEnter={_event => {
														this.setState({ permissionHelpPopUp: true });
													}}
													onMouseLeave={_event => {
														this.setState({ permissionHelpPopUp: false });
													}}
												/>
												{this.state.permissionHelpPopUp && (
													<div className="basic-popup">
														{t(`You can give your whole organization permission to view your objective, or just your team and managers`)}
												</div>
												)}
											</span>
										</div>
										<div className="pB10 kpi-permissionComp">
											<PermissionComp
												{...this.props}
												teamPermissionData={this.teamPermissionData}
												bizPermissionData={this.bizPermissionData}
												permissionData={this.permissionData}
												hide={false}
											/>
										</div>
									</div>
								) : (
										""
                )}
              </form>
            </div>
          }
          {
          this.state.externalSrc  &&
            <RetainUpdateModal
              selectedType={this.state.selectedTypeOpt}
              changeRadio={this.changeRadioOpt}
              exitDeleteModal={this.exitDeleteModal}
              deleteItems={this.saveItems}
              titleRetain={this.state.titleRetain ? this.state.titleRetain :  t('Save key result with new data type')}
              contentRetain ={this.state.contentRetain ?  this.state.contentRetain : t('Are you sure you want to save this key result with the new data type selected?')}
            />
          }
        </div>
      </ThemeProvider>
    )
  }
}

export default withTranslation()(KpiMarketPlaceDataSourceEdit);
